import CryptoJS from "crypto-js";
import forge from "node-forge";
import { RSA_PUBLIC_KEY } from "./config";

//------------ Encryption and decryption-------------------
export const gk = () => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789#@";
  let result = "";

  const randomValues = new Uint32Array(16); // 16 bytes for 128-bit key
  window.crypto.getRandomValues(randomValues);

  for (let i = 0; i < 16; i++) {
    const randomIndex = randomValues[i] % characters.length; // Ensure index is within bounds
    result += characters[randomIndex];
  }

  return result;
};

export const encryptWithRSA = async (aesKey) => {
  const publicKey = forge.pki.publicKeyFromPem(RSA_PUBLIC_KEY);
  const encryptedMessage = publicKey.encrypt(aesKey, "RSA-OAEP", {
    md: forge.md.sha256.create(), // Use SHA-256 for OAEP padding
  });
  // Convert the encrypted message to Base64
  return forge.util.encode64(encryptedMessage);
};

export const encryptData = (data, key) => {
  const plaintext = JSON.stringify(data);
  const aesKey = CryptoJS.enc.Utf8.parse(key);
  const iv = CryptoJS.enc.Utf8.parse(key);
  const encrypted = CryptoJS.AES.encrypt(plaintext, aesKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const decryptData = (encryptedData) => {
  const aesKey = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_SECRET_KEY);
  const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_FIXED_IV);
  const decrypted = CryptoJS.AES.decrypt(encryptedData, aesKey, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
};

//------------ Encryption and decryption End------------------

export const postFetch = async (url, data) => {
  debugger;
  const aeskey = gk();
  const encryptedData = encryptData(data, aeskey);
  const encryptAeskey = await encryptWithRSA(aeskey);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  try {
    const response = await fetch(`${baseUrl}${url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data: encryptedData, token: encryptAeskey }),
    });
    const encryptedResponse = await response.json();
    if (encryptedResponse) {
      return { data: decryptData(encryptedResponse.data), response };
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Same encrypted-request shape as postFetch, but for an endpoint that can
// return a raw binary file (e.g. account/preview-loi-docx/'s PDF) instead of
// the usual encrypted-JSON body — every other endpoint here always responds
// with {data: <encrypted>}, so a plain PDF response needs its own content-
// type check before deciding whether to decrypt or just hand back the blob.
// Mirrors client-admin-react's utils/apiUtils.js postFetchJwtFile, minus the
// JWT bearer header this public (unauthenticated) site doesn't send.
export const postFetchBlob = async (url, data) => {
  const aeskey = gk();
  const encryptedData = encryptData(data, aeskey);
  const encryptAeskey = await encryptWithRSA(aeskey);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const response = await fetch(`${baseUrl}${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ data: encryptedData, token: encryptAeskey }),
  });

  const contentType = response.headers.get("Content-Type") || "";
  if (contentType.startsWith("application/json")) {
    const encryptedResponse = await response.json();
    return { data: decryptData(encryptedResponse.data), response, blob: null };
  }

  const blob = await response.blob();
  return { data: null, response, blob };
};

export const getFetch = async (url) => {
  try {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const response = await fetch(`${baseUrl}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const encryptedResponse = await response.json();
    if (encryptedResponse) {
      return { data: decryptData(encryptedResponse.data), response };
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export function processApiError(data) {
  debugger;
  let errorMsg = "";
  // Case 1: If 'error' is a string
  if (typeof data?.error === "string") {
    errorMsg = data?.error || "";
  }
  // Case 2: If 'error' is an array of strings
  else if (Array.isArray(data?.error) && typeof data?.error[0] === "string") {
    errorMsg = data?.error.join("\n");
  }
  // Case 3: If 'error' is an object with key-value pairs
  else if (
    data?.error &&
    typeof data.error === "object" &&
    !Array.isArray(data.error)
  ) {
    for (const key in data.error) {
      if (data.error[key].length > 0 && Array.isArray(data.error?.[key])) {
        errorMsg += `${key}: ${data.error[key][0]}\n`;
      } else {
        //Specific case for error with the "Error" key directly in the object
        errorMsg = `Error: ${data?.error?.Error || ""}`;
      }
    }
  }

  // case 4:  If the 'error' is an array of arrays
  else if (Array.isArray(data?.error) && Array.isArray(data?.error[0])) {
    data.error.forEach((errorArray) => {
      if (Array.isArray(errorArray)) {
        errorMsg += errorArray.join("\n") + "\n";
      }
    });
  }

  // Case 5: If 'error' is an array of objects
  else if (Array.isArray(data?.error)) {
    data.error.forEach((item) => {
      if (
        typeof item === "object" &&
        item?.data &&
        item?.error &&
        typeof item.error === "string"
      ) {
        errorMsg += `${item.error}\n\n`;
      } else if (typeof item === "object") {
        for (const key in item) {
          if (Array.isArray(item[key])) {
            item[key].forEach((errorDetail) => {
              if (
                typeof errorDetail === "object" &&
                errorDetail.message &&
                errorDetail.user_list
              ) {
                errorMsg += `${key}: ${
                  errorDetail.message
                }\nAffected Users:\n${errorDetail.user_list.join(", ")}\n\n`;
              } else {
                errorMsg += `${key}: ${item[key]}\n`;
              }
            });
          }
        }
      }
    });
  }

  // Case 6: New case for "errors" array with email and Error properties
  else if (Array.isArray(data?.errors)) {
    data.errors.forEach((item) => {
      if (item?.email && Array.isArray(item?.Error)) {
        errorMsg += `Email: ${item.email}\n`;
        item.Error.forEach((error) => {
          errorMsg += `Error: ${error}\n`;
        });
      }
    });
  }

  // Case 7:  data is array of array with keys
  else {
    for (const key in data) {
      if (Array.isArray(data?.[key])) {
        errorMsg += `${key}: ${data?.[key]?.join(", ")}\n`;
      }
    }
  }

  return errorMsg || "";
}
